import { queryClient } from '@shared/libs/react-query';
import { useMutation } from '@tanstack/react-query';
import { createOrganization } from 'services/ClaimscoreApiService/Organizations';
import type {
  CreateOrganizationPayload,
  OrganizationIdResponse,
} from 'services/ClaimscoreApiService/Organizations/types';

export const useCreateOrganization = () =>
  useMutation<OrganizationIdResponse, Error, CreateOrganizationPayload>({
    mutationFn: (payload: CreateOrganizationPayload) =>
      createOrganization(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserPermissions'] });
    },
  });
